import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { LIST_ITEMS_SIZE } from 'config';
import { CONTENT_TYPES } from 'constants/content-types';
import ListItem, { LIST_ITEM_MARGIN } from './ListItem';
import { StyledListTitle, StyledHorizontalList } from './StyledComponents';

const BASE_LIST_CONFIG = {
  enterTo: 'last-focused',
  debounce: {
    time: 150,
    options: {
      leading: true,
      trailing: false,
      maxWait: 200,
    },
  },
};

const CollectionList = (props) => {
  const { id, index, title, items, contentType } = props;
  const { defaultSection, defaultIndex, startScrollIndex, config, onEnter, onFocus } = props;

  const itemSize = (LIST_ITEMS_SIZE[contentType] || LIST_ITEMS_SIZE.LARGE).width + LIST_ITEM_MARGIN;
  const renderSize = contentType !== CONTENT_TYPES.BANNER ? 8 : 4;

  const onEnterHandler = useCallback((item, i) => onEnter(item, i, { id, index }), [
    onEnter,
    id,
    index,
  ]);
  const onFocusHandler = useCallback((item, i) => onFocus(item, i, { id, index }), [
    onFocus,
    id,
    index,
  ]);

  return (
    <div key={id}>
      {title && <StyledListTitle>{title}</StyledListTitle>}
      <StyledHorizontalList
        listId={id}
        sectionName={id}
        defaultSection={defaultSection}
        defaultIndex={defaultIndex}
        startScrollIndex={contentType !== CONTENT_TYPES.BANNER ? startScrollIndex : 0}
        itemSize={itemSize}
        items={items}
        onEnter={onEnterHandler}
        onFocus={onFocusHandler}
        config={{ ...BASE_LIST_CONFIG, ...config }}
        renderSize={renderSize}
        itemComponent={ListItem[contentType]}
      />
    </div>
  );
};

CollectionList.propTypes = {
  id: PropTypes.string.isRequired,
  index: PropTypes.number.isRequired,
  title: PropTypes.string,
  items: PropTypes.array.isRequired,
  contentType: PropTypes.string,
  defaultSection: PropTypes.bool,
  defaultIndex: PropTypes.number,
  startScrollIndex: PropTypes.number,
  config: PropTypes.object,
  onEnter: PropTypes.func.isRequired,
  onFocus: PropTypes.func.isRequired,
};

export default CollectionList;
